import React from 'react'
import "./Pasco1.css"

import _pasco_1         from "../../assets/pasco/_pasco_1.png"
import _pasco_2         from "../../assets/pasco/_pasco_2.png"
import _pasco_3         from "../../assets/pasco/_pasco_3.png"
import _pasco_4         from "../../assets/pasco/_pasco_4.png"
import _pasco_5         from "../../assets/pasco/_pasco_5.png"
import _pasco_6         from "../../assets/pasco/_pasco_6.png"
import _pasco_7         from "../../assets/pasco/_pasco_7.png"
import _pasco_8         from "../../assets/pasco/_pasco_8.png"
import _pasco_9         from "../../assets/pasco/_pasco_9.png"



import Title from '../_title/Title'

export const appAndProjectDatabase1 = [
  // {
  //     id: 1,
  //     image: _pasco_1,
  //     titleTop: "AI-assisted practice library for BECE/WASSCE Examinations", 
  //     titleBottom: "AI-assisted practice library for BECE/WASSCE Examinations", 
  // },
  // {
  //     id: 2,
  //     image: _pasco_2,
  //     titleTop: "Instant Feedback and Recommendations",
  //     titleBottom: "Instant Feedback and Recommendations",
  // },
  // {
  //     id: 3,
  //     image: _pasco_3,
  //     titleTop: "Practice, Track and Improve your Performance ",
  //     titleBottom: "Practice, Track and Improve your Performance ",
  // },
  {
      id: 4,
      image: _pasco_4,
      titleTop: "Practice, Track and Improve your Performance",
      // titleBottom: "Practice, Track and Improve your Performance",
  },
  {
      id: 5,
      image: _pasco_5,
      titleTop: "Instant Feedback and Recommendations",
      // titleBottom: "Instant Feedback and Recommendations",
  },
  //   {
  //     id: 6,
  //     image: _pasco_6,
  //     titleTop: "Practice, Track and Improve your Performance ",
  //     titleBottom: "Practice, Track and Improve your Performance ",
  // },
  {
      id: 7,
      image: _pasco_7,
      titleTop: "University in Ghana Program Information",
      // titleBottom: "University in Ghana Program Information",
  },
  {
      id: 8,
      image: _pasco_8,
      titleTop: "Information on all Senior High Schools in Ghana",
      // titleBottom: "Information on all Senior High Schools in Ghana",
  }
  ,
  // {
  //     id: 9,
  //     image: _pasco_9,
  //     titleTop: "University in Ghana Program Information",
  //     titleBottom: "University in Ghana Program Information",
  // }
];



const Pasco1 = () => {
  return (
    <div className="pasco-1-main-container-1">
      <div className="pasco-1-sub-container-2">
        <Title title="EDUZOLVE PASCO"/>
        <Title title="Transforming High School Examinations in West Africa"/>
        <div className='pasco-1-sub-container-3'>
          <h2>
            EduZolve Pasco app is your ultimate tool for  BECE and WASSCE success, offering instant solutions, performance assessments, and comprehensive past questions to help you prepare with confidence anytime, anywhere.
          </h2>
        </div>

        <div className='pasco-1-sub-container-4'>
            {appAndProjectDatabase1.map((program, index) => (
              <Pasco1DisplayData key={program.id} program={program} index={index} />
            ))}
        </div>

    </div>
    </div>
  )
}


const Pasco1DisplayData = ({ program, index }) => {
  const backgroundClass =
    index === 0 || index === 3 ? "bg-style-1"   
      : "bg-style-2"; 

  return (
    <div className={`pasco-1-display-container-5 ${backgroundClass}`}>
        <div className="pasco-1-display-container-6">
        <h4>{program.titleTop}</h4>
      </div>
      <img src={program.image} alt="" />
      <div className="pasco-1-display-container-6">
        <h4>{program.titleBottom}</h4>
      </div>
    </div>
  );
};

export default Pasco1